export default __webpack_public_path__ + "static/media/manual-normal.f4a67ce9.svg";